import { render, staticRenderFns } from "./BannerHandlePopUp.vue?vue&type=template&id=031c8f36&scoped=true&"
import script from "./BannerHandlePopUp.vue?vue&type=script&lang=js&"
export * from "./BannerHandlePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031c8f36",
  null
  
)

export default component.exports